if (!customElements.get('promo-collapse')) {
  class PromoCollapse extends HTMLElement {
    constructor() {
      super();
      this.prevWidth = window.innerWidth;
    }
    
    connectedCallback() {
      this.interval = setInterval(this.handleCollapsing.bind(this), 100);
      
      window.addEventListener('resize', () => {
        if (this.prevWidth === window.innerWidth) return;
        this.prevWidth = window.innerWidth;
        this.handleCollapsing();
      });
    }
    
    disConnectedCallback() {
      window.removeEventListener('resize', () => {
        if (this.prevWidth === window.innerWidth) return;
        this.prevWidth = window.innerWidth;
        this.handleCollapsing();
      });
    }
    
    handleCollapsing() {
      if (getComputedStyle(this.closest('reveal-items')).opacity !== '1') return;
      if (this.interval) clearInterval(this.interval);

      this.classList.add('product-list__promo--collapsed');
      this.height = this.getBoundingClientRect()?.height;
      this.childHeight = this?.querySelector('.product-list__promo-content')?.getBoundingClientRect()?.height;

      if(this.height < this.childHeight) {
        this.setAttribute('aria-expanded', false);
        if (!this.button) {
          this.button = document.createElement('button');
          this.button.classList.add('product-list__promo-arrow');
          this.button.setAttribute('aria-controls', this.closest('.product-list__promo').id);
          this.button.innerHTML = 
            `<svg role="presentation" focusable="false" width="10" height="7" class="icon icon-chevron-bottom" viewBox="0 0 10 7">
              <path d="m1 1 4 4 4-4" fill="none" stroke="currentColor" stroke-width="2"></path>
            </svg>`
          this.insertAdjacentElement('beforeend', this.button);
          
          this.button.addEventListener('click', () => {
            this.classList.toggle('product-list__promo--collapsed');
            if (this.getAttribute('aria-expanded') == 'false') {
              this.setAttribute('aria-expanded', true);
            } else {
              this.setAttribute('aria-expanded', false);
            }
          });
        }
      } else {
        this.classList.remove('product-list__promo--collapsed');
        this.querySelector('.product-list__promo-arrow')?.remove();
        this.button = undefined;
        this.setAttribute('aria-expanded', true);
      }
    }
  }
  customElements.define('promo-collapse', PromoCollapse);
}